module.exports = __webpack_public_path__ + "img/winning_form-logo_black1.ec22969d.svg";